import React, {useCallback} from 'react';
import {Box} from '@mui/material';
import {useMatrixRoomContext} from '@/contexts/matrix/room';

import {MultimediaFileInfo} from '@/types/matrix';
import ImagePreviewBox from '@/components/matrix-chat/ui/image-preview-box';
import VideoPreviewBox from '@/components/matrix-chat/ui/video-preview-box';
interface MultimediaPreviewProps {
  multimediaFiles: MultimediaFileInfo[];
}

const MultimediaPreview: React.FC<MultimediaPreviewProps> = ({
  multimediaFiles
}) => {
  const {handleCancelMultimediaFileUpload} = useMatrixRoomContext();

  const handleClosePreview = useCallback(
    (index: number) => {
      handleCancelMultimediaFileUpload(index);
    },
    [handleCancelMultimediaFileUpload]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        gap: 1,
        maxWidth: '100%',
        overflow: 'auto'
      }}
    >
      {multimediaFiles.map((fileInfo, index) =>
        fileInfo.type === 'image' ? (
          <ImagePreviewBox
            key={`image-${index}`}
            url={fileInfo.previewUrl}
            index={index}
            onPreviewClose={() => handleClosePreview(index)}
          />
        ) : (
          <VideoPreviewBox
            key={`video-${index}`}
            url={fileInfo.previewUrl}
            index={index}
            onPreviewClose={() => handleClosePreview(index)}
          />
        )
      )}
    </Box>
  );
};

export default MultimediaPreview;
